import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PcFleetComponent } from './pc-fleet.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    PcFleetComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule
],
  exports:[
    PcFleetComponent
  ]
})
export class PcFleetModule { }
